// extracted by mini-css-extract-plugin
export default {"saarchbox":"TvcP3eqi5cSNSmze9Hef","uplne":"kHbCPOK8gFcaRjH0BErY"};